import React from "react";
import { SeparatorProps } from "./types";
import { cn } from "@paperclip-labs/whisk-sdk";

const Separator: React.FC<SeparatorProps> = ({
  solid = false,
  color = "border-[#8c8d8f]",
  opacity = "opacity-50",
  length = "min-w-[100px]",
  vertical = false,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        vertical ? "h-full w-[2px] border-l" : "mx-auto h-[2px] w-full border-t",
        color,
        opacity,
        length,
        {
          "border-solid": solid,
          "border-dashed": !solid,
        },
        className,
      )}
      {...props}
    />
  );
};

export default Separator;
